import React, { useState } from 'react';
import { View, Text, Image, Button, StyleSheet, TextInput, TouchableOpacity, ScrollView, Linking, ImageBackground } from 'react-native';
import Colors from './constants/Colors';
import LogoImage from './assets/images/logo.png'; 
import Home from './assets/images/sfondohome.png'; 
import Popup from './components/Popup'; 
import NavBar from './navBar';
import { Helmet } from 'react-helmet';
import { globalData } from './globalData';  // Importa il modulo globale
import Bianca2 from './assets/images/bianca2.jpg';
import Bianca1 from './assets/images/bianca1.jpg';
import MenuPanel from './menuPanel';

////import { useNavigation } from '@react-navigation/native';
import { useNavigate } from 'react-router-dom';

const sendEmailToDatabase = async (email) => {
  try {
    const response = await fetch('YOUR_API_ENDPOINT', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        email: {email}, 
        message: 'iscrivimi alla mail' 
      }),
    });

    if (!response.ok) {
      throw new Error('Errore durante l\'invio dell\'email');
    }
    
    return await response.json();
  } 
  catch (error) {
    console.error('Errore:', error);
  }
};

const LegalInfo = () => {
  const [visibleSection, setVisibleSection] = useState(null);

  const toggleSection = (section) => {
    setVisibleSection((prev) => (prev === section ? null : section));
  };

  return (
    <View style={styles.containerLegal}>
      {/* Policy & Privacy */}
      <TouchableOpacity
        style={styles.buttonLegal}
        onPress={() => toggleSection('privacy')}
      >
        <Text style={styles.buttonText}>
          {visibleSection === 'privacy' ? 'Nascondi Policy & Privacy' : 'Mostra Policy & Privacy'}
        </Text>
      </TouchableOpacity>
      {visibleSection === 'privacy' && (
        <View style={styles.legalContainer}>
          <Text style={styles.legalTitle}>Policy & Privacy</Text>
          <Text style={styles.legalText}>
          Questo sito non utilizza cookie o strumenti di tracciamento.
I dati forniti dagli utenti (come nome, indirizzo e-mail, indirizzo di spedizione, e informazioni di pagamento) saranno utilizzati esclusivamente per:
• Gestire gli ordini e le spedizioni dei prodotti acquistati.
• Fornire assistenza in caso di necessità.
I dati saranno trattati in conformità al GDPR (Regolamento UE 2016/679) e non saranno condivisi con terze parti, salvo nei casi necessari per l'elaborazione del pagamento o la gestione della spedizione (es. corriere).
Per richiedere l’accesso, la modifica o la cancellazione dei dati personali, gli utenti possono contattare: neveroutshop@gmail.com.
          </Text>
        </View>
      )}

      {/* Termini e Condizioni */}
      <TouchableOpacity
        style={styles.buttonLegal}
        onPress={() => toggleSection('terms')}
      >
        <Text style={styles.buttonText}>
          {visibleSection === 'terms' ? 'Nascondi Termini e Condizioni' : 'Mostra Termini e Condizioni'}
        </Text>
      </TouchableOpacity>
      {visibleSection === 'terms' && (
        <View style={styles.legalContainer}>
          <Text style={styles.legalTitle}>Termini e Condizioni</Text>
          <Text style={styles.legalText}>
            Le attività di vendita sono occasionali e non soggette all'obbligo di Partita IVA, ai sensi dell'art. 4 del
            DPR 633/72. Non essendo soggette all'obbligo di Partita IVA, non verranno emesse fatture, salvo su richiesta specifica e nei limiti della normativa applicabile. Gli acquisti prevedono restituzioni entro 14 giorni dalla ricezione, in conformità con la normativa sul diritto di recesso ( D.Lgs. 2006/2005 - Codice del Consumo).
            Il prodotto deve essere restituito integro, non usato; le spese di spedizione sono a carico del cliente salvo difetti del prodotto o non corrisponda a quanto ordinato. Per avviare la politica di reso il cliente deve contattare neveroutshop@gmail.com specificando nell'oggetto "RESTITUZIONE" e indicando i motivi. 
          </Text>
        </View>
      )}

      {/* Dati del Titolare */}
      <TouchableOpacity
        style={styles.buttonLegal}
        onPress={() => toggleSection('owner')}
      >
        <Text style={styles.buttonText}>
          {visibleSection === 'owner' ? 'Nascondi Dati del Titolare' : 'Mostra Dati del Titolare'}
        </Text>
      </TouchableOpacity>
      {visibleSection === 'owner' && (
        <View style={styles.legalContainer}>
          <Text style={styles.legalTitle}>Dati del Titolare</Text>
          <Text style={styles.legalText}>Nome: Alexandra Cucumetti</Text>
          <Text style={styles.legalText}>CF: CCMLND94S69B963C</Text>
          <Text style={styles.legalText}>Indirizzo: Via Iannelli, 33, 81100, Caserta, Italia</Text>
          <Text style={styles.legalText}>Email di contatto: neveroutshop@gmail.com</Text>
        </View>
      )}
    </View>
  );
};

const clearQueryParam = (param) => {
  const url = new URL(window.location.href);
  url.searchParams.delete(param);
  window.history.replaceState({}, document.title, url.pathname); // Aggiorna l'URL
};

const HomePage = () => {
  const getQueryParam = (param) => {
    const query = new URLSearchParams(window.location.search); // Legge i parametri dalla query string
    return query.get(param);
  };

  const success = getQueryParam('status'); // Recupera il valore di 'status' dalla query string

  console.error('status:', success);
  const [menuVisible, setMenuVisible] = useState(false);
  const toggleMenu = () => setMenuVisible(!menuVisible);

  const [popupVisible, setPopupVisible] = useState(false);
  const navigate = useNavigate();
  const [emailUser, setEmailUser] = useState('');

  const handleSubscription = async () => {
    sendEmailToDatabase();
    setPopupVisible(true);
    setEmailUser('');
  };

  const handleSeeProducts = () => {
    const direction="PageProducts";
    navigate(`/${direction.toLowerCase()}`);
 
  };

  React.useEffect(() => {
    if (success?.trim()  === 'true') {

      console.error('JSON.stringify(globalData)', JSON.stringify(globalData));
      fetch('https://SendConfirmedToNeverout.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          status: "true",
          message: "ciao", // Invia tutte le informazioni globali come stringa
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Email inviata:', data);
        })
        .catch((error) => {
          console.error('Errore nell\'invio della mail:', error);
        });

        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        //   body: JSON.stringify({
        //     status: success,
        //     message: JSON.stringify(globalData), // Invia tutte le informazioni globali come stringa
        //   }),
        // })
        //   .then((response) => response.json())
        //   .then((data) => {
        //     console.log('Email inviata:', data);
        //   })
        //   .catch((error) => {
        //     console.error('Errore nell\'invio della mail:', error);
        //   });
    }

    if (success != null ) {
      clearQueryParam('status');
    }
  }, [success]);

  return (
    <>
    <Helmet>
      <title>NeverOut - Abbigliamento Esclusivo Made in Italy</title>
      <meta 
        name="description" 
        content="Scopri il nostro abbigliamento Regular Fit, interamente Made in Italy." 
      />
    </Helmet>
    <View style={styles.container}>
    <NavBar toggleMenu={toggleMenu} />
    <MenuPanel isVisible={menuVisible} onClose={() => setMenuVisible(false)} />

      {/* Contenuto scrollabile */}
      <View style={styles.header}>
      <ScrollView Style={styles.header}>
      <ImageBackground source={Home} style={styles.promoSection}>
      {success?.trim()  === 'true' && (
        <View style={styles.panel}>
          <Text style={styles.panelTitle}>Congratulazioni!</Text>
          <Text style={styles.panelText}>
            Il tuo acquisto è andato a buon fine. A breve riceverai una mail di conferma. 
          </Text>
          <Text style={styles.panelText2}>
           La ricezione della mail protrebbe impiegarci un pò
          </Text>
        </View>
      )}
      {success?.trim()  === 'false' && (
        <View style={styles.panel}>
          <Text style={styles.panelTitle}>Errore nell'acquisto</Text>
          <Text style={styles.panelText}>
            Il tuo acquisto non è andato a buon fine. Ti invitiamo a riprovare o contattare l'assistenza.
          </Text>
        </View>
      )}
        <View style={styles.contentButton}>
          <View style={styles.contentSee}>
            <Text style={styles.text}>{"FALL WINTER '24"}</Text>
            <Text style={styles.textSubtitle}>{"100% cotone"}</Text>
            <Text style={styles.textSubtitle}>{"Regular Fit"}</Text>
            <Text style={styles.textSubtitle}>{"Made in Italy"}</Text>
            <TouchableOpacity style={styles.seeButton} onPress={handleSeeProducts}>
              <Text style={styles.seeButtonText}>Vedi prodotti</Text>
            </TouchableOpacity>
          </View>
        </View>
    </ImageBackground>

        <Popup title="NEWSLETTER" text="Ti abbiamo inviato un'e-mail di benvenuto. Grazie Mille" visible={popupVisible} onClose={() => setPopupVisible(false)} />
        
        <View style={styles.newsletterSection}>
          <Text style={styles.sectionTitle}>PRESTO potrai iscriverti alla nostra Newsletter</Text>
          <Text style={styles.sectionText}>Ricevi offerte esclusive e rimani aggiornato sulle ultime novità.</Text>
          
          <View style={styles.emailContainer}>
            <TextInput
              style={styles.emailInput}
              placeholder="Inserisci la tua email"
              value={emailUser}
              onChangeText={setEmailUser}
              keyboardType="email-address"
            />
            <TouchableOpacity style={styles.subscribeButton} onPress={handleSubscription}  disabled={true} >
              <Text style={styles.subscribeButtonText}>Iscriviti</Text>
            </TouchableOpacity>
          </View>

          <Text style={styles.privacyText}>
            Cliccando su "Iscriviti", confermi di aver letto e compreso la nostra  
          
            <Text style={styles.privacyText}> </Text> 
          <Text style={styles.privacyLink}>Informativa Privacy</Text> 
          <Text style={styles.privacyText}> </Text> 
             e di voler ricevere la newsletter e altre comunicazioni di marketing come indicato nella stessa.
          </Text>
        </View>

        <View style={styles.socialSection}>
          <Text style={styles.sectionText}>Seguici su</Text>
          <View style={styles.socialIconsContainer}>
            <TouchableOpacity onPress={() => Linking.openURL('https://www.instagram.com/neverout_shop/')}>
              <Image source={require('./assets/images/instagramIcon.png')} style={styles.socialIcon} />
            </TouchableOpacity>
            <TouchableOpacity onPress={() => Linking.openURL('https://www.tiktok.com/@neverout_shop?_t=ZN-8rhMtSofIJS&_r=1')}>
              <Image source={require('./assets/images/tiktokIcon.png')} style={styles.socialIcon} />
            </TouchableOpacity>
          </View>
        </View>
        <LegalInfo />
      </ScrollView>
      </View>
    </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
    flex: 1,
    backgroundColor: 'white',
  },
  menuButton: {
    width: 100,
    // Stili per il pulsante del menu
    padding: 10,
  },
  menuText: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  logoContainer: {
    height: 60,
  },
  logo: {
    height: 50,
    width: 300,
    padding:70,
  },
  searchInput: {
    height: 40,
    borderColor: '#ccc',
    borderWidth: 1,
    borderRadius: 5,
    paddingHorizontal: 10,
    width: 100, // Larghezza della barra di ricerca
  },
  header: {
    flex: 1,
    marginTop: 60,
    padding:0,
    backgroundColor: '#56898',
  },
  promoSection: {
    padding:0,
    alignItems: 'center',
    margin: 0,
    height:500,
  },
  homeImage:{
    height: 220,
    width:440,
    resizeMode: "contain",
  },
  promoImage: {
    height: 200,
    resizeMode: "contain",
    marginBottom: 10,
  },
  subscribeButton: {
    backgroundColor: '#ccc',
    paddingVertical: 10,
    paddingHorizontal:16,
    borderRadius: 4,
  },
  subscribeButtonText: {
    color: '#000',
    paddingHorizontal:16,
    fontSize: 16,
  },
  newsletterSection: {
    backgroundColor: '#f9f9f9',
    padding: 20,
    borderRadius: 8,
    marginVertical: 20,
    alignItems: 'center',
  },
  emailContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    marginVertical: 10,
  },
  emailInput: {
    flex: 1,
    height: 40,
    borderColor: '#ddd',
    borderWidth: 1,
    borderRadius: 4,
    paddingHorizontal: 10,
    fontSize: 14,
    marginRight: 8,
  },
  privacyText: {
    fontSize: 12,
    color: '#777',
    textAlign: 'center',
    marginTop: 16,
  },
  privacyLink: {
    color: '#000',
    textDecorationLine: 'underline',
  },
  socialSection: {
    alignItems: 'center',
    marginBottom: 20,
  },
  socialIconsContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  socialIcon: {
    width: 40,
    height: 40,
    marginHorizontal: 10,
  },
  thumbnail: {
    width: 70,
    height: 70,
    borderRadius: 10,
    marginRight: 12,
  },
  textSubtitle: {
    fontSize: 18,
    color: "#333",
    fontWeight: "200",
  },
  text: {
    fontSize: 33,
    color: "#333",
    fontWeight: "300",
  },
  icons: {
    fontSize: 16,
  },
  button: {
    backgroundColor: "#D97B33", // Colore del pulsante
    borderRadius: 10,
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
  buttonText: {
    fontSize: 16,
    color: "#FFF",
    fontWeight: "bold",
  },
  promoSection: {
    flex: 1,
    justifyContent: 'center', // Allinea tutto verticalmente al centro
    padding: 20,
    height:500,
  },
  promoSection: {
    height: 500, // Altezza dell'ImageBackground
    justifyContent: 'center', // Allinea al centro verticale
    alignItems: 'center', // Centra verticalmente
    padding: 20,
  },
  contentSee:{
  justifyContent: 'center', // Testo a sinistra e bottone a destra
  alignItems: 'center', // Centra verticalmente
},
  contentButton: {
    flex: 1, // Riempi tutto lo spazio disponibile
    flexDirection: 'row', // Posiziona gli elementi in riga (orizzontalmente)
    alignItems: 'center', // Centra verticalmente
  },
  seeButton: {
    borderWidth:1,
    borderColor:'#000',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 5,
    alignItems: 'center',
    justifyContent: 'center',
    margin:10,
  },
  seeButtonText: {
    color: '#000',
    fontSize: 16,
    fontWeight: '300',
  },
  subscribeButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
  containerLegal: {
    padding: 20,
    marginBottom:2,
    backgroundColor: '#D3D3D3',
  },
  buttonLegal: {
    backgroundColor: '#D3D3D3',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 5,
    alignItems: 'left',
    marginBottom: 10,
  },
  buttonText: {
    fontSize: 12,
    color: '#000',
    fontWeight: '200',
  },
  legalContainer: {
    marginTop: 10,
    backgroundColor: '#D3D3D3',
    padding: 15,
    borderRadius: 10,
    marginBottom: 20,
  },
  legalTitle: {
    fontSize: 12,
    fontWeight: '100',
    marginBottom: 10,
  },
  legalText: {
    fontSize: 12,
    marginBottom: 5,
  },
  panel: {
    width: '90%',
    padding: 20,
    backgroundColor: '#fff',
    borderRadius: 10,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOpacity: 0.2,
    shadowRadius: 5,
    elevation: 5,
  },
  panelTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  panelText: {
    fontSize: 12,
    textAlign: 'center',
    lineHeight: 22,
  },
  panelText2: {
    fontSize: 10,
    textAlign: 'center',
    lineHeight: 22,
  },
});

export default HomePage;
